import okiApi from '../../../api/oki-api';
import { OKI_TECHNICAL_FAILURE } from '../oki-vuex';
import { ROUTE_NAMES } from '../constants/oki-constants';

const OKI_SET_IMAGES_DATA = 'OKI_SET_IMAGES_DATA';

const okiCardUploadState = {
	imagesData: null
};

const convertBase64ToBlob = (dataURL) => {
	let blobBin = atob(dataURL.split(',')[1]);
	let array = [];
	for (let i = 0; i < blobBin.length; i++) {
		array.push(blobBin.charCodeAt(i));
	}
	return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
};
const okiCardUploadGetters = {
	getImage: (state) => {
		return state && state.imagesData && state.imagesData.masked;
	}
};
const okiCardUploadActions = {
	deleteImage({ commit, dispatch }) {
		dispatch('removeValidPages', ROUTE_NAMES.OSSZEGZES, { root: true });
		dispatch('removeVisitedPages', ROUTE_NAMES.OSSZEGZES, { root: true });
		commit(OKI_SET_IMAGES_DATA, null);
	},
	postCardImageForm({ commit, rootState, dispatch }, { data, taEvent }) {
		return new Promise((resolve, reject) => {
			commit(OKI_SET_IMAGES_DATA, data);
			let convertedImages = {};
			convertedImages.masked = convertBase64ToBlob(data.masked);
			convertedImages.cropped = convertBase64ToBlob(data.cropped);
			convertedImages.original = convertBase64ToBlob(data.original);
			okiApi.postImageForm(convertedImages, rootState.sessionId, taEvent, data.textColor).then(
				(response) => {
					resolve(response.data);
				},
				(err) => {
					if (err.response.data) {
						dispatch('collectErrorCodes', err.response.data, { root: true });
					}
					commit(OKI_TECHNICAL_FAILURE);
					reject(err);
				}
			);
		});
	},
	postTaDataCardUpload(context, taData) {
		okiApi.postTaData(taData);
	}
};
const okiCardUploadMutations = {
	[OKI_SET_IMAGES_DATA](state, data) {
		state.imagesData = data;
	}
};

export default {
	state: okiCardUploadState,
	getters: okiCardUploadGetters,
	mutations: okiCardUploadMutations,
	actions: okiCardUploadActions
};
